"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DiscountTerms = exports.DiscountCalculationType = exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
  DiscountType["discount"] = "DISCOUNT";
  DiscountType["promoCode"] = "PROMO_CODE";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var DiscountCalculationType;
(function (DiscountCalculationType) {
  DiscountCalculationType["percentage"] = "PERCENTAGE";
  DiscountCalculationType["fixedAmount"] = "FIXED_AMOUNT";
})(DiscountCalculationType = exports.DiscountCalculationType || (exports.DiscountCalculationType = {}));
var DiscountTerms;
(function (DiscountTerms) {
  DiscountTerms["participationInProjects"] = "PARTICIPATION_IN_PROJECTS";
  DiscountTerms["dateOfEarlyBooking"] = "DATE_OF_EARLY_BOOKING";
  DiscountTerms["quantityOfSingleTimeBoughtProducts"] = "QUANTITY_OF_SINGLE_TIME_BOUGHT_PRODUCTS";
})(DiscountTerms = exports.DiscountTerms || (exports.DiscountTerms = {}));